import React from 'react'
import { Navigate, useLocation } from 'react-router-dom';

const Auth = ({ children }) => {

    const savedItem = sessionStorage.getItem('SvastiUserID');
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const accessMethod = urlParams.get("access");
    if (savedItem) {
        return children
    } else {
        if (accessMethod) {
            sessionStorage.setItem("accessMethod", accessMethod); // Store the access method
          }
        return <Navigate to="/login" />;
    }

}

export default Auth